import Vue from 'vue';
import Component from 'vue-class-component';

const dialogWidth = '500';
const dialogMaxHeight = '550';
const dialogMinHeight = '275';
export const dialogXPadding = 'px-8';

const bigDialogWidth = '750';

@Component
export class DialogMixin extends Vue {
	/*
		Either
		1. use ActionDialog / WarningDialog
		OR
		2. use common Attrs
		[ref: CustomQuestionDialog]
	*/
	dialogAttrs = {
		persistent: true,
		scrollable: true,
		width: dialogWidth,
	};

	bigDialogAttrs = {
		...this.dialogAttrs,
		width: bigDialogWidth,
	};

	actionDialogCardAttrs = {
		minHeight: dialogMinHeight,
		maxHeight: dialogMaxHeight, //TODO: I tried to change this, it just change the content height and broke the layout, dialogbox not changed
	};

	noContentMinHeightDialogAttrs = {
		...this.actionDialogCardAttrs,
		minHeight: 0,
	};

	warningDialogCardAttrs = {
		height: dialogMinHeight,
	};

	dialogHeaderAttrs = {
		class: `py-6 ${dialogXPadding}`,
	};

	dialogTitleAttrs = {
		class: `subheader pa-0 text-break`,
	};

	dialogSubtitleAttrs = {
		class: `reminder-text mono700--text mt-1 pa-0`,
	};

	xsDialogCardContentAttrs = {
		class: `pt-0 ${dialogXPadding} body-text-black`,
	};

	dialogCardContentAttrs = {
		class: `pt-0 pb-9 ${dialogXPadding} body-text-black`,
	};

	xsDialogCardActionsAttrs = {
		class: `ma-0 ${dialogXPadding}`,
	};

	dialogCardActionsAttrs = {
		class: `ma-0 py-5 ${dialogXPadding}`,
	};

	/*
	TODO: change back the following to 
		1. ActionDialog / WarningDialog
		OR
		2. use above common Attrs

	-------------- form --------------
	1. LocaleField
	2. DateTimePicker

	-------------- common --------------
	1. CustomTableFilterParamsModal

	-------------- others --------------
	1. version update
	*/
}
